export const INITILIZE_USER = 'INITILIZE_USER';
export const ADD_USER_EMAIL_FULFILLED = 'ADD_USER_EMAIL_FULFILLED';
export const ADD_USER_EMAIL_PENDING = 'ADD_USER_EMAIL_PENDING';
export const ADD_USER_EMAIL_ERROR = 'ADD_USER_EMAIL_ERROR';
export const ADD_USER_EMAIL_TOKENCLEAR = 'ADD_USER_EMAIL_TOKENCLEAR';
